export const API_RETRY_COUNT = 3; // Number of retry attempts
export const API_RETRY_BASE_DELAY_MS = 1000; // Delay between retries in milliseconds

let config = null;
let configPromise: Promise<void> | null = null;

export function loadConfig(): Promise<void> {
  if (!configPromise) {
    configPromise = fetch('/config.json', { cache: 'no-store' })
      .then((res) => res.json())
      .then((data) => {
        config = data;
      })
      .catch((e) => {
        configPromise = null; // allow a retry on the next call
        throw e;
      });
  }
  return configPromise;
}

export function getConfig() {
  if (!config) {
    throw new Error('Config not loaded yet');
  }
  return config;
}
